import { MENU_BAR_COMPONENT } from '~/utils/api-response/cms'

export const state = () => ({
  menus: [],
  hoveredSubmenuIndex: null
})

export const actions = {
  getMenubars({ commit, rootState }) {
    const response = MENU_BAR_COMPONENT
    commit('setMenubars', response?.data)
    return response.data
  }
}

export const mutations = {
  setMenubars(state, menus) {
    if (!menus.length) return
    // Sort main menu and sub menu sequence
    const sortedMenubars = menus.sort((a, b) => ~~a?.sequence - ~~b?.sequence)
    sortedMenubars.forEach(menu => {
      menu?.items.sort((a, b) => a?.sequence - b?.sequence)
    })
    state.menus = sortedMenubars
  },
  setHoveredSubmenuIndex: (state, index) => {
    state.hoveredSubmenuIndex = index
  }
}
